module.exports = function() {
  return new Worker(__webpack_public_path__ + "9c022ad733b9075dd3fe.worker.js");
};